import RentPlace from './component';

export default RentPlace;
